
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DigitalPlatformsExperience = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Healthcare Digital Platforms & Experience
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <Link 
              to="/services" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Services
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Digital Platforms & Experience
            </span>
          </motion.div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image & Tagline */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Tag */}
              <span className="inline-block px-4 py-2 border border-gray-300 rounded-md text-gray-600 text-sm mb-6">
                HEALTHCARE WEB & APP
              </span>
              
              {/* Tagline */}
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
                The Leading <span className="text-[#19354a]">Healthcare Web & App DevelopmentPartner</span> To Build Your Medical Practice's Digital Presence!
              </h2>
              
              <img 
                src="/images/meta9.png" 
                alt="Healthcare Digital Platforms"
                className="w-full max-w-[450px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                In today's digital healthcare landscape, your website and patient portal are often the first impression potential patients have of your practice. A slow, outdated, or poorly designed medical platform can cost you valuable patient appointments and referrals. At Docmize, we build healthcare digital experiences that engage patients and streamline practice operations.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                Our team of expert healthcare developers and designers create <strong className="text-[#19354a]">HIPAA-compliant websites, patient portals, and medical mobile applications</strong> that are not just visually appealing but also optimized for patient engagement, appointment bookings, and secure health information exchange. From telemedicine platforms to practice management systems, we deliver healthcare-specific solutions tailored to your medical specialty.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                Whether you need a new medical practice website, a complete revamp of your existing platform, or a custom patient engagement app for Android and iOS, Docmize has you covered. We combine cutting-edge healthcare technology with user-centric design to create digital experiences that set your practice apart.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-gray-900 font-semibold leading-relaxed mb-8"
              >
                Ready to transform your practice's digital presence? Partner with Docmize and let's build something exceptional together!
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Link 
                  to="/contact" 
                  className="inline-block px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
                >
                  GET A QUOTE
                </Link>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/* WHY CHOOSE US - BLUE SECTION */}
      <section className="relative py-20 overflow-hidden">
        <div 
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #0f1c3f 0%, #1a2d5e 50%, #152349 100%)'
          }}
        />
        
        <div className="absolute inset-0 overflow-hidden">
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 50px,
                rgba(59, 130, 246, 0.1) 50px,
                rgba(59, 130, 246, 0.1) 52px
              )`
            }}
          />
          <div className="absolute top-0 left-[20%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[40%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/30 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[60%] w-[3px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
          <div className="absolute top-0 left-[80%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/15 to-transparent transform rotate-[30deg] origin-top"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">
              Why Choose Our Healthcare Development Services?
            </h2>
            <p className="text-white/70 text-lg">
              Here's why doctors and hospitals trust us with their digital platforms:
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-5xl mx-auto">
            
            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">HIPAA-compliant websites and patient portals for medical practices</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Patient-focused design that increases appointment bookings</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Medical practice website revamp and ongoing maintenance</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Healthcare-optimized speed and secure hosting solutions</p>
              </motion.div>
            </div>

            <div className="space-y-8">
              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Telemedicine and patient engagement mobile apps</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">EHR/EMR integrations and healthcare API connections</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Online appointment scheduling and patient intake systems</p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex items-start gap-4"
              >
                <span className="text-[#39a5d3] text-2xl font-bold">»</span>
                <p className="text-white text-lg">Healthcare-focused UI/UX for optimal patient experiences</p>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      {/* OUR SERVICES SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Our Healthcare Digital Platform Services
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive web and app development solutions for medical practices
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Service 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Medical Practice Websites</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                HIPAA-compliant websites optimized for patient acquisition and appointment bookings.
              </p>
            </motion.div>

            {/* Service 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Patient Portal Development</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Secure patient portals for medical records, lab results, and communications.
              </p>
            </motion.div>

            {/* Service 3 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Website Revamp & Redesign</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Modernize your medical practice website with fresh design and features.
              </p>
            </motion.div>

            {/* Service 4 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare Speed Optimization</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Lightning-fast medical websites with HIPAA-compliant hosting solutions.
              </p>
            </motion.div>

            {/* Service 5 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Telemedicine Apps</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Secure telehealth platforms for virtual consultations and patient care.
              </p>
            </motion.div>

            {/* Service 6 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">EHR/EMR Integration</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Seamless integration with electronic health record systems and APIs.
              </p>
            </motion.div>

            {/* Service 7 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Appointment Systems</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Online booking and scheduling systems for seamless patient appointments.
              </p>
            </motion.div>

            {/* Service 8 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.8 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-[#19354a] mb-3">Healthcare UI/UX Design</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Patient-centric design for exceptional healthcare digital experiences.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/* ENTRUST US SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
                Entrust us to Build
              </h2>
              <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
                Your Healthcare Platform,
              </h2>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-2">
                Outshine Competing Practices
              </h3>
              <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-8">
                and Grow Your Patient Base.
              </h3>

              {/* Checklist Items */}
              <div className="space-y-5">
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Build HIPAA-compliant, patient-focused websites that convert visitors into appointments from day one.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    We develop secure telemedicine apps and patient portals that enhance care delivery across all devices.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Speed-optimized medical platforms with secure, compliant hosting ensure your practice is always accessible.
                  </p>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    EHR integrations and appointment systems streamline practice operations and improve patient satisfaction.
                  </p>
                </motion.div>
              </div>
            </motion.div>

            {/* Right - Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex justify-center"
            >
              <img 
                src="/images/promotion.png" 
                alt="Build Your Healthcare Platform"
                className="w-full max-w-[500px] h-auto"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Reap the Benefits of Healthcare Development Services
            </h2>
            <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-6">
              AT <span className="text-[#19354a]">DOCMIZE</span>
            </h3>
            <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Our comprehensive healthcare development services are designed to build digital platforms that drive patient acquisition and scale with your medical practice.
            </p>
          </motion.div>

          {/* Benefit 1 - Image Right */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#fff4e6] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
                  Discovery & Healthcare Planning
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We start by understanding your medical practice goals, patient demographics, and specialty-specific requirements. Our team creates a detailed roadmap ensuring your healthcare platform meets HIPAA compliance and delivers exceptional patient experiences.
                </p>
              </div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e8f4fc]"
            >
              <img 
                src="/images/meta10.png" 
                alt="Healthcare Discovery & Planning"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
          </div>

          {/* Benefit 2 - Image Left */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#e6f7f0] order-2 lg:order-1"
            >
              <img 
                src="/images/meta11.png" 
                alt="Healthcare Design & Prototyping"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e6f2e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
                  Patient-Centric Design & Prototyping
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Our healthcare designers create patient-focused UI/UX designs with interactive prototypes. You'll see and approve every design element before development begins, ensuring the platform enhances patient engagement and appointment conversions.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Benefit 3 - Image Right */}
          <div className="grid lg:grid-cols-2 gap-0 mb-8">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#f0e6f7] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
                  Secure Development & HIPAA Testing
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Our healthcare developers build your platform using secure technologies and healthcare-specific best practices. Rigorous HIPAA compliance testing ensures your website or app protects patient data and performs flawlessly across all devices.
                </p>
              </div>
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#e6e9f7]"
            >
              <img 
                src="/images/meta12.png" 
                alt="Secure Development & Testing"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
          </div>

          {/* Benefit 4 - Image Left */}
          <div className="grid lg:grid-cols-2 gap-0">
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="bg-[#fce8e8] order-2 lg:order-1"
            >
              <img 
                src="/images/meta13.png"
                alt="Launch & Medical Support"
                className="w-full h-full min-h-[280px] object-cover"
              />
            </motion.div>
            <motion.div 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-[#fff0e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
            >
              <div>
                <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
                  Launch & Healthcare IT Support
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  We handle deployment, secure hosting setup, and go-live for your medical practice. Post-launch, our healthcare IT team provides ongoing maintenance, security updates, and support to ensure your platform continues attracting and serving patients effectively.
                </p>
              </div>
            </motion.div>
          </div>

        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Frequently Asked Questions about
            </h2>
            <h3 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
              Healthcare Development Services.
            </h3>
          </motion.div>

          {/* FAQ Content - Image Left, Questions Right */}
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            
            {/* Left - Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex justify-center lg:sticky lg:top-24"
            >
              <img 
                src="/images/faq-img.png" 
                alt="FAQ Healthcare Development"
                className="w-full max-w-[220px] h-auto"
              />
            </motion.div>

            {/* Right - FAQ Items */}
            <div className="space-y-4">
              {[
                {
                  question: "How long does it take to build a medical practice website?",
                  answer: "Timeline depends on complexity and HIPAA requirements. A basic medical practice website can be completed in 3-4 weeks, while a full HIPAA-compliant platform with patient portal typically takes 6-10 weeks. Telemedicine apps and complex EHR integrations may take 10-16 weeks depending on features."
                },
                {
                  question: "Are your healthcare platforms HIPAA-compliant?",
                  answer: "Yes! All our healthcare websites, patient portals, and medical apps are built with HIPAA compliance at the core. We implement secure data encryption, access controls, audit logs, and follow all necessary technical safeguards to protect patient health information (PHI)."
                },
                {
                  question: "Do you provide secure hosting for medical websites?",
                  answer: "Absolutely! We offer HIPAA-compliant hosting solutions with 99.9% uptime guarantee, SSL certificates, daily backups, DDoS protection, and 24/7 security monitoring. Our hosting includes Business Associate Agreements (BAA) as required for healthcare data."
                },
                {
                  question: "Can you integrate with our existing EHR/EMR system?",
                  answer: "Yes, we have extensive experience integrating with major EHR/EMR systems like Epic, Cerner, Allscripts, and others. We can build custom APIs and data bridges to ensure seamless communication between your website/app and your practice management systems."
                },
                {
                  question: "Do you build telemedicine and patient engagement apps?",
                  answer: "Yes! We develop secure telemedicine platforms for virtual consultations, patient engagement apps with appointment scheduling, prescription refills, lab results, and secure messaging. All apps support both Android and iOS with full HIPAA compliance."
                }
              ].map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                >
                  <details className="group">
                    <summary className="flex items-center justify-between p-5 bg-[#19354a] rounded-lg cursor-pointer list-none">
                      <span className="font-semibold text-white">{faq.question}</span>
                      <span className="text-white text-2xl font-light group-open:hidden">+</span>
                      <span className="text-white text-2xl font-light hidden group-open:block">−</span>
                    </summary>
                    <div className="px-5 py-4 bg-gray-50 rounded-b-lg text-gray-700 leading-relaxed -mt-2">
                      {faq.answer}
                    </div>
                  </details>
                </motion.div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Build Your Healthcare Platform?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let our expert healthcare developers create a HIPAA-compliant platform that drives patient acquisition and enhances care delivery for your medical practice.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DigitalPlatformsExperience;